import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LegacyApp from "@/contract/LegacyApp";
import AriApp, { ARI_BASE } from "@/contract/AriApp";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path={`${ARI_BASE}/*`} element={<AriApp />} />
        <Route path="/*" element={<LegacyApp />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
